'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';

import { getSimpleProductPricing } from '../actions/get-product-pricing';

interface SimplePricing {
  amount: number;
  currency: string;
}

interface PricingContextType {
  pricing: SimplePricing;
  isLoading: boolean;
}

const PricingContext = createContext<PricingContextType | undefined>(undefined);

export function PricingProvider({ children }: { children: React.ReactNode }) {
  const [pricing, setPricing] = useState<SimplePricing>({
    amount: 0.99,
    currency: '€',
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const result = await getSimpleProductPricing();

        setPricing(result);
      } catch (error) {
        console.error('Error fetching pricing:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPricing();
  }, []);

  return (
    <PricingContext.Provider value={{ pricing, isLoading }}>
      {children}
    </PricingContext.Provider>
  );
}

export function usePricing() {
  const context = useContext(PricingContext);
  if (context === undefined) {
    throw new Error('usePricing must be used within a PricingProvider');
  }
  return context;
}
